import * as React from "react"

import { cn } from "@/lib/utils"

// `min-[768px]:text-sm`, not `md:text-sm` — see the note in input.tsx. The 16px
// floor exists to stop iOS zooming on focus, which depends on the device rather
// than on the width of the box the field sits in, and `md:` measures the latter.
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 min-[768px]:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
